import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { staffStatus, setStaffPasscode, changeStaffPasscode } from '@generated/server/staff.server';

export const checkStaff = createServerFn({ method: 'POST' })
  .validator(z.object({ pass: z.string().max(200).optional() }))
  .handler(async ({ data }) => staffStatus(data.pass));

export const setupStaff = createServerFn({ method: 'POST' })
  .validator(z.object({ pass: z.string().min(6).max(200) }))
  .handler(async ({ data }) => ({ ok: await setStaffPasscode(data.pass) }));

export const changeStaff = createServerFn({ method: 'POST' })
  .validator(z.object({ oldPass: z.string().max(200), newPass: z.string().min(6).max(200) }))
  .handler(async ({ data }) => ({ ok: await changeStaffPasscode(data.oldPass, data.newPass) }));
